<div class="leads-navigation-page">
  <app-header></app-header>

  <!-- Container principal -->
  <div class="navigation-wrapper">
    <!-- Breadcrumb dentro do container, mas fora do card -->
    <div class="breadcrumb-container">
      <div class="breadcrumb">
        <a (click)="navigateToHome()" class="breadcrumb-item">Tela inicial</a>
        <span class="breadcrumb-separator">></span>
        <a (click)="navigateByBreadcrumb()" class="breadcrumb-item">{{ breadcrumbLabel }}</a>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item active">Detalhes do Lead</span>
      </div>
    </div>

    <!-- Título dentro do container, mas fora do card -->
    <h1 class="page-title-main">Detalhes do Lead</h1>

    @if (hasNavigationBar) {
      <!-- Navigator Menu dentro do container, mas fora do card -->
      <div class="navigator-menu">
        <button class="nav-tab" [class.active]="currentPage === 0" (click)="navigateToPage(0)">
          Informações Gerais
        </button>
        <button class="nav-tab" [class.active]="currentPage === 1" (click)="navigateToPage(1)">
          Oferta
        </button>
        <button class="nav-tab" [class.active]="currentPage === 2" (click)="navigateToPage(2)">
          Histórico
        </button>
      </div>
    }

    <!-- Container do conteúdo com setas nas laterais -->
    <div class="content-wrapper">
      <!-- Container do conteúdo (CARD BRANCO) -->
      <div class="leads-details-content">
        <!-- Conteúdo da página -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
